import * as yup from 'yup';
import { IAgent } from 'domain/entities/Agent/Agent';
import { IInvitationCode } from 'domain/entities/InvitationCode/InvitationCode';

export const COMPANY_USER_ROLE = {
    USER: 10,
    SUPER_USER: 20,
    ADMIN_USER: 30,
    SUPPORT_USER: 40,
} as const;

export type AgentUserRole = (typeof COMPANY_USER_ROLE)[keyof typeof COMPANY_USER_ROLE];

export const USER_ROLE_LABEL = {
    10: 'ユーザー',
    20: '管理者',
    30: 'システム管理者',
} as const;

export const USER_ROLE_LABEL_FOR_EDIT = {
    10: 'ユーザー',
    20: '管理者',
} as const;

export const GENDER = {
    1: '男性',
    2: '女性',
    0: 'それ以外',
} as const;

export const PROFILE_STAGE = {
    ONLY_PASSWORD: 1,
    NEED_COMPANY_INFO: 2,
    NEED_USER_PROFILE: 3,
    COMPLETE: 4,
} as const;
export type ProfileStage = (typeof PROFILE_STAGE)[keyof typeof PROFILE_STAGE];

export interface IAgentUser {
    id: number;
    agent: IAgent | null;
    last_name: string;
    first_name: string;
    last_name_kana: string | null;
    first_name_kana: string | null;
    email: string;
    birthday: string | null;
    gender: number;
    icon_image: string | null;
    status: number;
    role: AgentUserRole;
    department: string | null;
    job: string | null;
    mail_news_receive: boolean;
    account_profile_stage?: ProfileStage;
    invitation_code?: IInvitationCode | null;
}

export interface IAgentUserForList {
    id: number;
    email: string;
    last_name: string;
    first_name: string;
    role: number;
    department: string | null;
    job: string | null;
    icon_image: string | null;
    phone_number: string | null;
}

export const agentUserSchema = yup.object({
    id: yup.number().required(),
    last_name: yup.string().required(),
    first_name: yup.string().required(),
    last_name_kana: yup.string().nullable(),
    first_name_kana: yup.string().nullable(),
    email: yup.string().required(),
    birthday: yup.string().nullable(),
    gender: yup.number().required(),
    icon_image: yup.string().nullable().defined(),
    status: yup.number().required(),
    role: yup.number().oneOf(Object.values(COMPANY_USER_ROLE)).required(),
    department: yup.string().nullable().defined(),
    job: yup.string().nullable().defined(),
    mail_news_receive: yup.boolean(),
    phone_number: yup.string().nullable().defined(),
});

export const isNotRegistrationComplete = (agentUser: IAgentUser | null): boolean => {
    if (!agentUser) {
        return false;
    }
    return (
        agentUser.account_profile_stage === PROFILE_STAGE.ONLY_PASSWORD ||
        agentUser.account_profile_stage === PROFILE_STAGE.NEED_COMPANY_INFO
    );
};
